const HeroSectionSkeleton = () => {
  return (
    <section
      className="container max-w-full py-3"
      aria-roledescription="carousel"
      aria-label="Offers and promotions"
    >
      <div
        role="status"
        aria-label="Loading banner"
        className="rounded-[0.625rem] sm:rounded-[24px] overflow-hidden bg-gray-200 animate-pulse w-full aspect-[377/240] sm:aspect-[1520/368]"
      />
    </section>
  )
}

export default HeroSectionSkeleton
